<section role="status" aria-live="polite" [attr.aria-label]="label">
  <span class="sr-only">{{ label }}…</span>
  <div aria-hidden="true" [ngSwitch]="variant">
    <div *ngSwitchCase="'overall'" class="totals"><div class="total" *ngFor="let item of totals"><span class="bone value"></span><span class="bone line"></span></div></div>
    <span *ngSwitchCase="'updating'" class="bone progress"></span>
    <ng-container *ngSwitchDefault>
      <div [class.activity-shell]="variant === 'leaderboards'">
        <span *ngIf="variant === 'leaderboards'" class="bone heading"></span>
        <div class="podium"><div class="leader" *ngFor="let item of leaders"><span class="bone badge"></span><span class="bone line name"></span><span class="bone value"></span><span class="bone line tier"></span></div></div>
        <span class="bone disclosure"></span>
      </div>
      <div *ngIf="variant === 'leaderboards'" class="collapsed" ><span class="bone heading"></span><span class="bone icon"></span></div>
      <div *ngIf="variant === 'leaderboards'" class="collapsed" ><span class="bone heading"></span><span class="bone icon"></span></div>
    </ng-container>
  </div>
</section>
